import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { LegalPage } from '../../Common/HelpCenter';
import { TERMS_TITLE, TERMS_SECTIONS } from './legalContent';

const CLSFITermsConditions = () => (
  <LegalPage
    brand="CLS"
    header={<Header showTopBar={false} />}
    footer={<Footer />}
    title={TERMS_TITLE}
    sections={TERMS_SECTIONS}
  />
);

export default CLSFITermsConditions;
